import styled from 'styled-components';
import { IconButton2 } from '@frameio/vapor';
import { IconMoreHorizontal } from '@frameio/vapor-icons';

/**
 * Shared props and styling for both Worspace and Project context menu buttons
 */
export const MenuButton = styled(IconButton2).attrs({
  icon: <IconMoreHorizontal />,
  size: 'small' as const,
  variant: 'dimmed' as const,
  tabIndex: 0,
})`
  visibility: hidden;

  *:hover > &,
  *[data-focused='true'] > & {
    visibility: visible;
  }
`;
